import { Tabs, Tab } from '@mui/material'
import {
  Assessment as ReportIcon,
  TrendingUp as PnlIcon,
  AccountBalance as AgingIcon,
  AccountBalanceWallet as BalanceSheetIcon,
  Receipt as SalesTaxIcon,
} from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'

const TABS = [
  { label: 'Advance Tax', icon: <ReportIcon />, path: '/reports' },
  { label: 'Sales Tax', icon: <SalesTaxIcon />, path: '/reports/sales-tax' },
  { label: 'Profit & Loss', icon: <PnlIcon />, path: '/reports/pnl' },
  { label: 'A/R Aging', icon: <AgingIcon />, path: '/reports/ar-aging' },
  { label: 'Balance Sheet', icon: <BalanceSheetIcon />, path: '/reports/balance-sheet' },
]

interface ReportsTabsProps {
  activeTab: 0 | 1 | 2 | 3 | 4
}

const ReportsTabs = ({ activeTab }: ReportsTabsProps) => {
  const navigate = useNavigate()
  const advanceTaxEnabled = useSelector((state: RootState) => state.auth.user?.company_features?.advance_tax !== false)
  const salesTaxEnabled = useSelector((state: RootState) => state.auth.user?.company_features?.sales_tax_invoice === true)

  return (
    <Tabs value={(activeTab === 0 && !advanceTaxEnabled) || (activeTab === 1 && !salesTaxEnabled) ? false : activeTab} sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}>
      {TABS.map((tab, i) => (i !== 0 || advanceTaxEnabled) && (i !== 1 || salesTaxEnabled) && (
        <Tab
          key={tab.path}
          value={i}
          icon={tab.icon}
          iconPosition="start"
          label={tab.label}
          onClick={i !== activeTab ? () => navigate(tab.path) : undefined}
        />))}
    </Tabs>
  )
}

export default ReportsTabs
